import axiosInstance from './axios-config';

/**
 * Récupère l'URL CloudFront pour le replay d'un stream terminé
 * @param streamId L'identifiant du stream dont on veut récupérer le replay
 * @returns L'URL CloudFront du replay ou null si pas trouvé
 */
export const getRecordingUrl = async (streamId: string): Promise<string | null> => {
  try {
    const response = await axiosInstance.get(`/videos/recording-url/${encodeURIComponent(streamId)}`);

    if (response.data?.url) {
      return response.data.url;
    } else {
      return null;
    }
  } catch (error: any) {
    if (error.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

/**
 * Récupère l'URL de la vignette pour un stream
 * @param streamId L'identifiant du stream dont on veut récupérer la vignette
 * @returns L'URL CloudFront de la vignette ou null si pas trouvé
 */
export const getThumbnailUrl = async (streamId: string): Promise<string | null> => {
  try {
    const response = await axiosInstance.get(`/videos/thumbnail-url/${encodeURIComponent(streamId)}`);

    if (response.data?.url) {
      return response.data.url;
    } else {
      return null;
    }
  } catch (error: any) {
    throw error;
  }
};

/**
 * Récupère l'URL CloudFront pour le replay d'un channel IVS (dernier replay)
 * @param channelId L'identifiant du channel (ARN ou id)
 * @returns L'URL CloudFront du replay ou null si pas trouvé
 */
export const getRecordingUrlByChannel = async (channelId: string): Promise<string | null> => {
  try {
    const response = await axiosInstance.get(`/videos/recording-url/by-channel/${encodeURIComponent(channelId)}`);
    if (response.data?.url) {
      return response.data.url;
    } else {
      return null;
    }
  } catch (error: any) {
    if (error.response?.status === 404) {
      return null;
    }
    throw error;
  }
};
